import {NonEmploymentIncome} from '@data/schema/loan-appication/non-employment-income';

export class EmploymentIncome{
    sTotalEmploymentIncome : number;
    sBaseIncome : number;
    sSelfEmploymentIncome : number;
    sNonEmploymentIncome : NonEmploymentIncome[] = [];
    nonEmploymentIncomeDummyType ="";

}
